import { render } from "./ArrowBackward.vue?vue&type=template&id=17531ac8"
const script = {}
script.render = render

export default script